import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const statExaminationCounterModule: LocaleModule = {
  name: "statExaminationCounter",
  messages: { en: en, it: it },
};
